import React from 'react';
import clsx from 'clsx';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './RadioCard.module.scss';

interface RadioCardProps {
    title: string;
    description?: string;
    icon?: IconDefinition;
    meta?: React.ReactNode;
    badge?: React.ReactNode;
    checked: boolean;
    disabled?: boolean;
    onSelect: () => void;
    className?: string;
}

export const RadioCard: React.FC<RadioCardProps> = ({
    title,
    description,
    icon,
    meta,
    badge,
    checked,
    disabled,
    onSelect,
    className
}) => (
    <button
        type="button"
        role="radio"
        aria-checked={checked}
        disabled={disabled}
        className={clsx(styles.root, { [styles.checked]: checked, [styles.disabled]: disabled }, className)}
        onClick={onSelect}
    >
        <span className={styles.radio}>
            <span />
        </span>
        <span className={styles.content}>
            <span className={styles.titleRow}>
                {icon && <FontAwesomeIcon icon={icon} />}
                <span className={styles.title}>{title}</span>
                {badge}
            </span>
            {description && <span className={styles.description}>{description}</span>}
        </span>
        {meta && <span className={styles.meta}>{meta}</span>}
    </button>
);

export default RadioCard;
